/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, total: NonNullable<unknown> }} Keyword_Optimizer_Applied_CountInputs */

const en_keyword_optimizer_applied_count = /** @type {(inputs: Keyword_Optimizer_Applied_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} of ${i?.total} applied`)
};

const de_keyword_optimizer_applied_count = /** @type {(inputs: Keyword_Optimizer_Applied_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} von ${i?.total} angewendet`)
};

const fr_keyword_optimizer_applied_count = /** @type {(inputs: Keyword_Optimizer_Applied_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} sur ${i?.total} appliqués`)
};

const es_keyword_optimizer_applied_count = /** @type {(inputs: Keyword_Optimizer_Applied_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} de ${i?.total} aplicados`)
};

const it_keyword_optimizer_applied_count = /** @type {(inputs: Keyword_Optimizer_Applied_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} di ${i?.total} applicati`)
};

const nl_keyword_optimizer_applied_count = /** @type {(inputs: Keyword_Optimizer_Applied_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} van ${i?.total} toegepast`)
};

const pl_keyword_optimizer_applied_count = /** @type {(inputs: Keyword_Optimizer_Applied_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zastosowano ${i?.count} z ${i?.total}`)
};

const fi_keyword_optimizer_applied_count = /** @type {(inputs: Keyword_Optimizer_Applied_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}/${i?.total} sovellettu`)
};

const da_keyword_optimizer_applied_count = /** @type {(inputs: Keyword_Optimizer_Applied_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} af ${i?.total} anvendt`)
};

const sv_keyword_optimizer_applied_count = /** @type {(inputs: Keyword_Optimizer_Applied_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} av ${i?.total} tillämpade`)
};

/**
* | output |
* | --- |
* | "{count} of {total} applied" |
*
* @param {Keyword_Optimizer_Applied_CountInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_applied_count = /** @type {((inputs: Keyword_Optimizer_Applied_CountInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Applied_CountInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_applied_count(inputs)
	if (locale === "fr") return fr_keyword_optimizer_applied_count(inputs)
	if (locale === "es") return es_keyword_optimizer_applied_count(inputs)
	if (locale === "it") return it_keyword_optimizer_applied_count(inputs)
	if (locale === "nl") return nl_keyword_optimizer_applied_count(inputs)
	if (locale === "pl") return pl_keyword_optimizer_applied_count(inputs)
	if (locale === "fi") return fi_keyword_optimizer_applied_count(inputs)
	if (locale === "da") return da_keyword_optimizer_applied_count(inputs)
	if (locale === "sv") return sv_keyword_optimizer_applied_count(inputs)
	return en_keyword_optimizer_applied_count(inputs)
});